module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isShow) ? _c('div', {
    staticClass: ["dof-toast-wrapper"]
  }, [_c('div', {
    staticClass: ["dof-toast-inner"]
  }, [(_vm.type) ? _c('image', {
    staticClass: ["icon"],
    attrs: {
      "src": _vm.icon
    }
  }) : _vm._e(), _c('text', {
    staticClass: ["dof-toast", "dof-toast-content"]
  }, [_vm._v(_vm._s(_vm.content))])])]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-15b37ec4!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-toast/index.vue
// module id = 580
// module chunks = 0 1